'use strict';

var Event = {};

Event.isDrag = function (e) {
    return (
        (e.type === 'touchmove' && e.originalEvent.touches.length === 1) || (e.type === 'mousemove' && e.buttons === 1)
    );
};

Event.fingerDistance = function (e) {
    return Math.sqrt(
        Math.pow(e.touches[0].clientX - e.touches[1].clientX, 2) +
            Math.pow(e.touches[0].clientY - e.touches[1].clientY, 2)
    );
};

module.exports = Event;
